import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	useAgent: {
		id: 'backlog.card-list.card.context-menu.use-agent-non-final',
		defaultMessage: 'Use Agent',
		description: 'Label for context menu action to use agent on the selected issue(s)',
	},
});
